import { render, staticRenderFns } from "./GeneralReport.vue?vue&type=template&id=0952bc52&scoped=true"
import script from "./GeneralReport.vue?vue&type=script&lang=js"
export * from "./GeneralReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952bc52",
  null
  
)

export default component.exports